import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { Utility } from 'src/app/core/common';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-manage-service-request',
  templateUrl: './manage-service-request.component.html',
  styleUrls: ['./manage-service-request.component.scss']
})
export class ManageServiceRequestComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private userService: UserService,
    private spinner: SpinnerService, private sharedService: SharedService) { }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  criteria: any = { q: '', fromTime: undefined, toTime: undefined, from: 0, limit: 50 };
  list: any[];
  total: number;

  async ngOnInit() {
    await this.load();
  }


  async load() {
    this.spinner.show();
    const result = await this.userService.adminGetServiceRequests(this.criteria);
    this.list = result.list;
    this.total = result.total;
    this.spinner.hide();
  }

}
